import { render, staticRenderFns } from "./AddTransportModal.vue?vue&type=template&id=44d8dbdc&"
import script from "./AddTransportModal.vue?vue&type=script&lang=ts&"
export * from "./AddTransportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports